angular.module('unica_invitation_transfer_event.invitation_transfer_event_controllers')

.controller('InvitationTransferEventListController', function(
	CONFIG,
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	InvitationTransferEventListService, InvitationTransferListService,
	InvitationTransferEventEditService, InvitationTransferEventDeleteService
) {
	$scope.invitationTransfersEvent = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.notificationType = null;
	$scope.$on('event_loaded', function() {
		$scope.notificationType = $rootScope.eventData.notification_type;
	});


	$scope.loadTransferEventsRecap = function()
	{
		$scope.showLoader();
		InvitationTransferListService
			.getListGrouped( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();
				if ( data ) {
					$scope.invitationTransfers = data;
				}
			});
	};
	$scope.loadTransferEventsRecap();


	$scope.loadInvitationTransferEvents = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		InvitationTransferEventListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationTransfersEvent = $scope.invitationTransfersEvent.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}

			});
	};

	$scope.loadInvitationTransferEvents();

	$scope.notifyInvitationTransferEvent = function() {
		if ( !$scope.notificationType ) {
			$scope.showErrorMsg(
				'Per poter inviare le notifiche è necessario impostare il tipo di notifica nella pagina di modifica evento'
			);
		} else {
			$confirm({
				title: 'Sei sicuro di voler procedere con l\'invio delle notifiche?',
				text: 'Confermi l\'invio delle notifiche (' + $scope.notificationType + ') a tutti gli utenti assegnati?'
			}).then(function() {

				$scope.showLoader();
				InvitationTransferEventEditService
					.sendNotifications( { event_id: $scope.event_id }  )
					.then(function(data) {
						$scope.hideLoader();

						// if ( data ) {
						// 	angular.forEach($scope.invitationTransfersEvent, function(invitationTransferEvent, key) {
						// 		if ( invitationTransferEvent.id === invitationTransferEventId ) {
						// 			$scope.invitationTransfersEvent.splice(key, 1);
						// 		}
						// 	});
						//
						// 	$scope.loadTransferEventsRecap();

						// I non raggiungibili sono quelli che non hanno numero impostato o non hanno l'app
						$scope.showSuccessMsg(
							'Invio di ' + data.notifiche +  ' notifiche ' + data.type + ' avviato con successo!' +
							' (' + data.not_defined + ' non raggiungibili)', ''
						);
						// }

					});

			}, function() {
				// Cancel
			});
		}
	};

	$scope.deleteInvitationTransferEvent = function(invitationTransferEventId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare il Transfer Assegnato?',
			text: 'Confermi la cancellazione del Transfer Assegnato?'
		}).then(function() {

			$scope.showLoader();
			InvitationTransferEventDeleteService
				.delete( invitationTransferEventId  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.invitationTransfersEvent, function(invitationTransferEvent, key) {
							if ( invitationTransferEvent.id === invitationTransferEventId ) {
								$scope.invitationTransfersEvent.splice(key, 1);
							}
						});

						$scope.loadTransferEventsRecap();

						$scope.showSuccessMsg('Transfer Assegnato eliminato con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});

	};



	$scope.clearinvitationTransfers = function() {

		$confirm({
			title: 'Sei sicuro di voler eliminare tutti i Transfer Assegnati?',
			text: 'Confermi la cancellazione di tutti i Transfer Assegnati?'
		}).then(function() {

			$scope.showLoader();
			InvitationTransferEventDeleteService
				.erase( $scope.event_id )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.invitationTransfersEvent = [];

						$scope.loadTransferEventsRecap();

						$scope.showSuccessMsg('Stanze Assegnate eliminate con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});
	};


	$scope.asyncSelected = undefined;
	$scope.ibNoResults = false;
	$scope.loadingInvitations = false;
	$scope.searchInvitationTransfer = function(search) {
		$scope.loadingInvitations = true;
		InvitationTransferEventListService
			.search( $scope.event_id, search )
			.then(function(data) {
				$scope.loadingInvitations = false;
				if ( data.length > 0 ) {
					$scope.ibNoResults = false;
					$scope.invitationTransfersEvent = data;
					return data;
				} else {
					$scope.invitationTransfersEvent = [];
					$scope.ibNoResults = true;
					return null;
				}
			});
	};

	$scope.$watch('asyncSelected', function() {
		if ( $scope.asyncSelected !== undefined && $scope.asyncSelected.length == 0 ) {
			$scope.invitationTransfersEvent = [];
		}
	});


	$scope.downloadExportTransferEvent = false;
	$scope.exportTransferEventUrl      = '';

	$scope.prepareExportTransferEventUrl = function() {
		$scope.showLoader();
		InvitationTransferEventListService
			.exportTransferEvent( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportTransferEvent = true;
					$scope.exportTransferEventUrl      = url;
				}
			});
	};

});